import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

const NavigationOptions = defaultTemplate(({ options, t }) => {
    if (!options) {
        return null;
    }

    if (options.loading) {
        return (
            <span className='display--ib spc--left--tny align--v--text-top'>
                <i className='u-icon u-icon--xmed u-icon--sync u-rotate--login' />
            </span>
        )
    }
    if (options.title && options.title !== '') {
        return (
            <div>
                <div className="u-flex--primary"> 
                    <span className="u-mar--right--tny">
                        {options.hideColon ? '' : ':'} {t(options.title)}   
                    </span>
                    <div className="content__header__actions">
                        {options.onEdit && options.onEdit !== '' &&                
                        (
                            <a className="btn btn--base btn--light u-mar--right--tny"  target='_blank' onClick={options.onEdit}>
                                <i className="u-icon u-icon--med u-icon--edit--dark"></i>
                            </a>
                        )}   
                        {options.onPreview && options.onPreview !== '' &&                
                        (
                            <a className="btn btn--base btn--light u-mar--right--tny"  target='_blank' onClick={options.onPreview}>
                                <i className="u-icon u-icon--sml u-icon--preview--dark"></i>
                            </a>
                        )}    
                        {options.onCalendar && options.onCalendar !== '' &&                
                        (
                            <a className="btn btn--base btn--light u-mar--right--tny"  target='_blank' onClick={options.onCalendar}>
                                <i className="u-icon u-icon--sml u-icon--schedules"></i>
                            </a>
                        )}  
                        {options.openModal && options.openModal !== '' &&                
                        (      
                            <a className="btn btn--base btn--light" target='_blank' onClick={options.openModal}>
                                <i className="u-icon u-icon--sml u-icon--download--brand"></i>
                            </a>
                        )}     
                    </div>
                </div>
                {
                    options.subTitleComponent 
                }
            </div> 
        )          
    }

    return null;
});

function NavigationTemplate({ title, navigationOptions, t, overrideDefaultContent, children }) {

    return !overrideDefaultContent ? (
        <React.Fragment>
            {/* <div className='row'>
                <div className="col col-sml-12">
                    <div className='breadcrumbs'> */}
                        {/* {_.map(breadcrumbs, (breadcrumb, index) => {
                            const isLast = index === lastIndex;
                            const navigate =
                                breadcrumb.route && !isLast
                                    ? () => routerStore.goTo(breadcrumb.route)
                                    : null;

                            const breadcrumbTitle = t(breadcrumb.title);
                            return (
                                <span className={'breadcrumbs__item' + (!navigate ? ' disabled' : '')} key={index} {...(navigate ? { onClick: navigate } : {})}>
                                    {breadcrumbTitle}{isLast ? '' : <span className='breadcrumbs__spacer u-icon u-icon--tny u-icon--arrow-right' /> }
                                </span>
                            );
                        })}  */}
                    {/* </div>
                </div>
            </div> */}
            <div className="content__header is-legacy">
                <h2 className="u-flex--primary">
                    {t(title)}
                    <NavigationOptions options={navigationOptions} />
                </h2>

                {children ?
                    <div className="content__header__actions hide--on-print">
                        {renderChildren(children)}
                    </div> : null
                }
            </div>
        </React.Fragment>
    ) : renderChildren(children);
}

function renderChildren(children) {
    return typeof children === 'function' ? children() : children;
}

NavigationTemplate.propTypes = {
    title: PropTypes.string,
    setSubTitleComponent: PropTypes.any,
    navigationOptions: PropTypes.object,
    breadcrumbs: PropTypes.array,
    routerStore: PropTypes.object,
    t: PropTypes.func,
    children: PropTypes.any,
    overrideDefaultContent: PropTypes.bool
};

NavigationTemplate.defaultProps = {
    overrideDefaultContent: false,
};

export default defaultTemplate(NavigationTemplate);
